import { Route } from '@angular/router';
import { Error403Component } from './error-403.component';

export const error403Routes: Route[] = [
  {
    path: '',
    component: Error403Component,
  },
];
